const prefix = process.env.REACT_APP_STORAGE_KEY_PREFIX || "argus-";
export const storageKeys = {
	NEW_CHECKOUT_SHIPPING_ADDRESS:
		prefix +
		`${process.env.REACT_APP_STORAGE_KEY_CHECKOUT_DELIVERY_ADDRESS || "checkout_delivery_address"}`,
	GUEST_CURRENT_VEHICLE:
		prefix +
		`${process.env.REACT_APP_STORAGE_KEY_GUEST_CURRENT_VEHICLE || "guest_current_vehicle"}`,
	USER_ANNOUNCEMENTS: prefix + `user_announcements`
};
